export const FacebookConstants = Object.freeze({
  VERSION: 'v10.0',
  CONNECTED: 'connected',
  AUTHORIZATION_EXPIRED: 'authorization_expired',
  NOT_AUTHORIZED: 'not_authorized',
} as const);
